import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import ContributorResultsContext from './context';
import Keywords from '../common/components/keywords';
import useGetKeywordsUsedByContributor from '../../../services/keywords/keywords-used-by-contributor-service';

export default function TopKeywords({ profile }) {
  const { dispatch } = React.useContext(ContributorResultsContext);
  const [{ data }, executeQuery] = useGetKeywordsUsedByContributor(profile.id, 5);

  React.useEffect(() => {
    executeQuery();
  }, [executeQuery]);

  React.useEffect(() => {
    if (_.get(data, 'keywords.length')) {
      dispatch({ type: 'setKeywords', payload: data.keywords });
    }
  }, [data, dispatch]);

  const props = { data, relation: 'assigned by', query: profile.name };
  return <Keywords {...props} />;
}

TopKeywords.propTypes = {
  profile: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
};
